export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAIL = "SIGNUP_FAIL";

export const ACCOUNT_VERIFICATION_SUCCESS = "ACCOUNT_VERIFICATION_SUCCESS";
export const ACCOUNT_VERIFICATION_FAIL = "ACCOUNT_VERIFICATION_FAIL";

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";

export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAIL = "FORGOT_PASSWORD_FAIL";

export const FORGOT_PASSWORD_OTP_ADDED_TO_REDUX_SUCCESS =
  "FORGOT_PASSWORD_OTP_ADDED_TO_REDUX_SUCCESS";
export const FORGOT_PASSWORD_OTP_ADDED_TO_REDUX_FAIL =
  "FORGOT_PASSWORD_OTP_ADDED_TO_REDUX_FAIL";

export const PASSWORD_CHANGED_SUCCESS = "PASSWORD_CHANGED_SUCCESS";
export const PASSWORD_CHANGED_FAIL = "PASSWORD_CHANGED_FAIL";

export const FLUSH_ALL_AUTHENTICATION_REDUX_STATE =
  "FLUSH_ALL_AUTHENTICATION_REDUX_STATE";

export const TOKEN_REFRESH_SUCCESS = "TOKEN_REFRESH_SUCCESS";
export const TOKEN_REFRESH_FAILED = "TOKEN_REFRESH_FAILED";

export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";

export const GET_ERRORS = "GET_ERRORS";
export const CREATE_MESSAGE = "CREATE_MESSAGE";

export const CSV_FILE_UPLOAD_SUCCESS = "CSV_FILE_UPLOAD_SUCCESS";
export const CSV_FILE_UPLOAD_FAIL = "CSV_FILE_UPLOAD_FAIL";

export const FILE_UPLOAD_TRIGGERED_SUCCESS = "FILE_UPLOAD_TRIGGERED_SUCCESS";
export const FILE_UPLOAD_TRIGGERED_FAILED = "FILE_UPLOAD_TRIGGERED_FAILED";

export const RESET_ANALYSIS_REDUX_STATE = "RESET_ANALYSIS_REDUX_STATE";

export const FETCH_CSV_SUCCESS = "FETCH_CSV_SUCCESS";
export const FETCH_CSV_FAIL = "FETCH_CSV_FAIL";

export const DELETE_CSV_SUCCESS = "DELETE_CSV_SUCCESS";
export const DELETE_CSV_FAIL = "DELETE_CSV_FAIL";

export const FETCH_CHAT_SESSIONS_SUCCESS = "FETCH_CHAT_SESSIONS_SUCCESS";
export const FETCH_CHAT_SESSIONS_FAIL = "FETCH_CHAT_SESSIONS_FAIL";

export const FETCH_INDIVIDUAL_CHAT_SESSION_SUCCESS =
  "FETCH_INDIVIDUAL_CHAT_SESSION_SUCCESS";
export const FETCH_INDIVIDUAL_CHAT_SESSION_FAIL =
  "FETCH_INDIVIDUAL_CHAT_SESSION_FAIL";

export const CONTINUE_CHAT_SESSION_ADD_SESSION_ID_TO_REDUX =
  "CONTINUE_CHAT_SESSION_ADD_SESSION_ID_TO_REDUX";

export const MESSAGE_SENT_TO_CHAT_BOT_SUCCESS =
  "MESSAGE_SENT_TO_CHAT_BOT_SUCCESS";
export const MESSAGE_SENT_TO_CHAT_BOT_FAIL = "MESSAGE_SENT_TO_CHAT_BOT_FAIL";

export const SET_HAS_RESPONDED = "SET_HAS_RESPONDED";

export const NEW_CHAT_SESSION_STARTED_SUCCESS =
  "NEW_CHAT_SESSION_STARTED_SUCCESS";
export const NEW_CHAT_SESSION_STARTED_FAIL = "NEW_CHAT_SESSION_STARTED_FAIL";

export const RESET_CONTINUE_CHAT_SESSION = "RESET_CONTINUE_CHAT_SESSION";

export const CHAT_SESSION_IS_NEW_RESET = "CHAT_SESSION_IS_NEW_RESET";

export const SESSION_DELETE_SUCCESS = "SESSION_DELETE_SUCCESS";
export const SESSION_DELETE_FAIL = "SESSION_DELETE_FAIL";

export const CSV_ANALYSIS_SUCCESS = "CSV_ANALYSIS_SUCCESS";
export const CSV_ANALYSIS_FAIL = "CSV_ANALYSIS_FAIL";

export const SENT_TO_MAIL = "RECIEVE_IN_MAIL";
export const RENDER_ON_SITE = "RENDER_ON_SITE";

export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_FAIL = "FETCH_USER_FAIL";

export const ADD_ANALYSIS_FILE_NAMES_TO_REDUX =
  "ADD_ANALYSIS_FILE_NAMES_TO_REDUX";

export const RESET_ANALYSIS_MESSAGE_REDUX_STATE =
  "RESET_ANALYSIS_MESSAGE_REDUX_STATE";

export const FETCH_INDIVIDUAL_FILE_SUCCESS = "FETCH_INDIVIDUAL_FILE_SUCCESS";
export const FETCH_INDIVIDUAL_FILE_FAIL = "FETCH_INDIVIDUAL_FILE_FAIL";

export const RENDER_PDF_FILE_SUCCESS = "RENDER_PDF_FILE_SUCCESS";
export const RENDER_PDF_FILE_FAIL = "RENDER_PDF_FILE_FAIL";

export const ADD_ANALYSIS_FILE_ID_TO_REDUX = "ADD_ANALYSIS_FILE_ID_TO_REDUX";

export const FAKE_CSV_ANALYSIS_SUCCESS = "FAKE_CSV_ANALYSIS_SUCCESS";

export const COLLAPSE_CX2_SIDEBAR_ACTIVE = "COLLAPSE_CX2_SIDEBAR_ACTIVE";
export const COLLAPSE_CX2_SIDEBAR_INACTIVE = "COLLAPSE_CX2_SIDEBAR_INACTIVE";

export const PDF_ANALYSIS_COMPLETE_POP_UP = "PDF_ANALYSIS_COMPLETE_POP_UP";
export const PDF_ANALYSIS_COMPLETE_POP_UP_RESET =
  "PDF_ANALYSIS_COMPLETE_POP_UP_RESET";

export const FETCH_ALL_USERS_SUCCESS = "FETCH_ALL_USERS_SUCCESS";
export const FETCH_ALL_USERS_FAIL = "FETCH_ALL_USERS_FAIL";

export const BAN_USER_SUCCESS = "BAN_USER_SUCCESS";
export const BAN_USER_FAIL = "BAN_USER_FAIL";

export const SERVICE_ACCESS_GRANTED_SUCCESS = "SERVICE_ACCESS_GRANTED_SUCCESS";
export const SERVICE_ACCESS_GRANTED_FAIL = "SERVICE_ACCESS_GRANTED_FAIL";

export const CLEAR_INDIVIDUAL_CHAT_SESSION = "CLEAR_INDIVIDUAL_CHAT_SESSION";

export const HAS_CLICKED_ON_SEND_ACTIVE = "HAS_CLICKED_ON_SEND_ACTIVE";
export const HAS_CLICKED_ON_SEND_INACTIVE = "HAS_CLICKED_ON_SEND_INACTIVE";

export const FETCH_FORM_TYPES_SUCCESS = "FETCH_FORM_TYPES_SUCCESS";
export const FETCH_FORM_TYPES_FAIL = "FETCH_FORM_TYPES_FAIL";

export const CREATE_FORM_INSTANCE_SUCCESS = "CREATE_FORM_INSTANCE_SUCCESS";
export const CREATE_FORM_INSTANCE_FAIL = "CREATE_FORM_INSTANCE_FAIL";

export const FETCH_FORM_STRUCTURE_SUCCESS = "FETCH_FORM_STRUCTURE_SUCCESS";
export const FETCH_FORM_STRUCTURE_FAIL = "FETCH_FORM_STRUCTURE_FAIL";

export const ADD_FORM_INSTANCE_ID_TO_REDUX = "ADD_FORM_INSTANCE_ID_TO_REDUX";

export const FORM_ENTRY_ADDED_SUCCESS = "FORM_ENTRY_ADDED_SUCCESS";
export const FORM_ENTRY_ADDED_FAIL = "FORM_ENTRY_ADDED_FAIL";

export const RESET_FORM_REDUX_STATE = "RESET_FORM_REDUX_STATE";

export const FORM_ENTRY_RENDERED_SUCCESS = "FORM_ENTRY_RENDERED_SUCCESS";
export const FORM_ENTRY_RENDERED_FAIL = "FORM_ENTRY_RENDERED_FAIL";

export const ADDED_AI_MODEL = "ADDED_AI_MODEL";

export const FETCH_ALL_WHATSAPP_MESSAGES_SUCCESS =
  "FETCH_ALL_WHATSAPP_MESSAGES_SUCCESS";
export const FETCH_ALL_WHATSAPP_MESSAGES_FAILED =
  "FETCH_ALL_WHATSAPP_MESSAGES_FAILED";

export const FETCH_INDIVIDUAL_WHATSAPP_MESSAGES_SUCCESS =
  "FETCH_INDIVIDUAL_WHATSAPP_MESSAGES_SUCCESS";
export const FETCH_INDIVIDUAL_WHATSAPP_MESSAGES_FAILED =
  "FETCH_INDIVIDUAL_WHATSAPP_MESSAGES_FAILED";

export const SEND_MESSAGE_SUCCESS = "SEND_MESSAGE_SUCCESS";
export const SEND_MESSAGE_FAILED = "SEND_MESSAGE_FAILED";

export const RESET_HAS_RESPONDED_TO_WHATSAPP_MESSAGE =
  "RESET_HAS_RESPONDED_TO_WHATSAPP_MESSAGE";

export const SUMMARIZE_MESSAGE_SUCCESS = "SUMMARIZE_MESSAGE_SUCCESS";
export const SUMMARIZE_MESSAGE_FAILED = "SUMMARIZE_MESSAGE_FAILED";

export const ADD_PHONE_NUMBER = "ADD_PHONE_NUMBER";

export const FETCH_ALL_MESSAGE_FOR_OVERVIEW_SUCCESS =
  "FETCH_ALL_MESSAGE_FOR_OVERVIEW_SUCCESS";
export const FETCH_ALL_MESSAGE_FOR_OVERVIEW_FAILED =
  "FETCH_ALL_MESSAGE_FOR_OVERVIEW_FAILED";

export const GENERATED_AI_RESPONSE_SUCCESS = "GENERATED_AI_RESPONSE_SUCCESS";
export const GENERATED_AI_RESPONSE_FAILED = "GENERATED_AI_RESPONSE_FAILED";

export const GET_INDIVIDUAL_AI_GENERATED_RESPONSE_SUCCESS =
  "GET_INDIVIDUAL_AI_GENERATED_RESPONSE_SUCCESS";
export const GET_INDIVIDUAL_AI_GENERATED_RESPONSE_FAILED =
  "GET_INDIVIDUAL_AI_GENERATED_RESPONSE_FAILED";

export const RESET_IS_FETCHED_AI_RESPONSE = "RESET_IS_FETCHED_AI_RESPONSE";

export const GET_MESSAGE_SENTIMENT_SUCCESS = "GET_MESSAGE_SENTIMENT_SUCCESS";
export const GET_MESSAGE_SENTIMENT_FAILED = "GET_MESSAGE_SENTIMENT_FAILED";

export const ADD_MESSAGE_TO_REDUX = "ADD_MESSAGE_TO_REDUX";

export const AI_RESPONSE_EDITED_SUCCESS = "AI_RESPONSE_EDITED_SUCCESS";
export const AI_RESPONSE_EDITED_FAILED = "AI_RESPONSE_EDITED_FAILED";

export const FETCH_INCOMING_MESSAGES_FOR_OVERVIEW_SUCCESS =
  "FETCH_INCOMING_MESSAGES_FOR_OVERVIEW_SUCCESS";
export const FETCH_INCOMING_MESSAGES_FOR_OVERVIEW_FAILED =
  "FETCH_INCOMING_MESSAGES_FOR_OVERVIEW_FAILED";

export const GENERATE_SUMMARY_FOR_OVERVIEW_SUCCESS =
  "GENERATE_SUMMARY_FOR_OVERVIEW";
export const GENERATE_SUMMARY_FOR_OVERVIEW_FAILED =
  "GENERATE_SUMMARY_FOR_OVERVIEW_FAILED";

export const CONTACT_SAVED_SUCCESS = "CONTACT_SAVED_SUCCESS";
export const CONTACT_SAVED_FAILED = "CONTACT_SAVED_FAILED";

export const RESET_SEND_MESSAGE_REDUX = "RESET_SEND_MESSAGE_REDUX";

export const ADD_USER_NAME = "ADD_USER_NAME";

export const MESSAGE_ADDED_TO_BROADCAST_QUEUE_SUCCESS =
  "MESSAGE_ADDED_TO_BROADCAST_QUEUE_SUCCESS";
export const MESSAGE_ADDED_TO_BROADCAST_QUEUE_FAILED =
  "MESSAGE_ADDED_TO_BROADCAST_QUEUE_FAILED";

export const QUEUED_MESSAGE_SENT_SUCCESS = "QUEUED_MESSAGE_SENT_SUCCESS";
export const QUEUED_MESSAGE_SENT_FAILED = "QUEUED_MESSAGE_SENT_FAILED";

export const RESET_BROADCAST_MESSAGE_STATUS = "RESET_BROADCAST_MESSAGE_STATUS";

export const FILE_UPLOAD_SUCCESS = "FILE_UPLOAD_SUCCESS";
export const FILE_UPLOAD_FAILED = "FILE_UPLOAD_FAILED";

export const INGESTION_SUCCESS = "INGESTION_SUCCESS";
export const INGESTION_FAILED = "INGESTION_FAILED";

export const ADDED_FILE_ID_TO_REDUX = "ADD_FILE_ID_TO_REDUX";

export const IS_INGESTING = "IS_INGESTING";

export const INGESTION_STATE_RESET = "INGESTION_STATE_RESET";

export const ALL_KNOWLEDGE_BASE_STATE_RESET = "ALL_KNOWLEDGE_BASE_STATE_RESET";

export const GET_FILES_SUCCESS = "GET_FILES_SUCCESS";
export const GET_FILES_FAILED = "GET_FILES_FAILED";

export const RESEND_OTP_SUCCESS = "RESEND_OTP_SUCCESS";
export const RESEND_OTP_FAIL = "RESEND_OTP_FAIL";

// Add optimistic message to chat without waiting for server response
export const ADD_OPTIMISTIC_MESSAGE = "ADD_OPTIMISTIC_MESSAGE";

export const CREATE_BULK_ACCOUNT_SUCCESS = "CREATE_BULK_ACCOUNT_SUCCESS";
export const CREATE_BULK_ACCOUNT_FAIL = "CREATE_BULK_ACCOUNT_FAIL";

export const FETCH_ALL_DEPARTMENTS_SUCCESS = "FETCH_ALL_DEPARTMENTS_SUCCESS";
export const FETCH_ALL_DEPARTMENTS_FAIL = "FETCH_ALL_DEPARTMENTS_FAIL";

export const CREATE_DEPARTMENT_SUCCESS = "CREATE_DEPARTMENT_SUCCESS";
export const CREATE_DEPARTMENT_FAIL = "CREATE_DEPARTMENT_FAIL";

export const UPDATE_DEPARTMENT_SUCCESS = "UPDATE_DEPARTMENT_SUCCESS";
export const UPDATE_DEPARTMENT_FAIL = "UPDATE_DEPARTMENT_FAIL";

export const DELETE_DEPARTMENT_SUCCESS = "DELETE_DEPARTMENT_SUCCESS";
export const DELETE_DEPARTMENT_FAIL = "DELETE_DEPARTMENT_FAIL";

// Folder Upload Types
export const FOLDER_UPLOAD_SUCCESS = "FOLDER_UPLOAD_SUCCESS";
export const FOLDER_UPLOAD_FAILED = "FOLDER_UPLOAD_FAILED";
export const FOLDER_INGESTION_SUCCESS = "FOLDER_INGESTION_SUCCESS";
export const FOLDER_INGESTION_FAILED = "FOLDER_INGESTION_FAILED";
export const IS_FOLDER_INGESTING = "IS_FOLDER_INGESTING";
export const FOLDER_INGESTION_STATE_RESET = "FOLDER_INGESTION_STATE_RESET";

// File Delete (SFTP + DB record)
export const DELETE_FILE_SUCCESS = "DELETE_FILE_SUCCESS";
export const DELETE_FILE_FAILED = "DELETE_FILE_FAILED";

// Document Delete (vector DB)
export const DELETE_DOCUMENT_SUCCESS = "DELETE_DOCUMENT_SUCCESS";
export const DELETE_DOCUMENT_FAILED = "DELETE_DOCUMENT_FAILED";

// Document Replace (vector DB)
export const REPLACE_DOCUMENT_SUCCESS = "REPLACE_DOCUMENT_SUCCESS";
export const REPLACE_DOCUMENT_FAILED = "REPLACE_DOCUMENT_FAILED";

export const EDIT_ANALYSIS_OUTPUT_SUCCESS = "EDIT_ANALYSIS_OUTPUT_SUCCESS";
export const EDIT_ANALYSIS_OUTPUT_FAIL = "EDIT_ANALYSIS_OUTPUT_FAIL";

export const FETCH_CHAT_TRACKER_USERS_SUCCESS =
  "FETCH_CHAT_TRACKER_USERS_SUCCESS";
export const FETCH_CHAT_TRACKER_USERS_FAIL = "FETCH_CHAT_TRACKER_USERS_FAIL";

export const FETCH_CHAT_TRACKER_CONVERSATION_SUCCESS =
  "FETCH_CHAT_TRACKER_CONVERSATION_SUCCESS";
export const FETCH_CHAT_TRACKER_CONVERSATION_FAIL =
  "FETCH_CHAT_TRACKER_CONVERSATION_FAIL";

export const FETCH_CHAT_TRACKER_STATS_SUCCESS =
  "FETCH_CHAT_TRACKER_STATS_SUCCESS";
export const FETCH_CHAT_TRACKER_STATS_FAIL = "FETCH_CHAT_TRACKER_STATS_FAIL";

export const BULK_ASSIGN_DEPARTMENTS_SUCCESS =
  "BULK_ASSIGN_DEPARTMENTS_SUCCESS";
export const BULK_ASSIGN_DEPARTMENTS_FAIL = "BULK_ASSIGN_DEPARTMENTS_FAIL";

// Multi-department assignment types
export const ASSIGN_USER_DEPARTMENTS_SUCCESS = "ASSIGN_USER_DEPARTMENTS_SUCCESS";
export const ASSIGN_USER_DEPARTMENTS_FAIL = "ASSIGN_USER_DEPARTMENTS_FAIL";
export const REMOVE_USER_DEPARTMENT_SUCCESS = "REMOVE_USER_DEPARTMENT_SUCCESS";
export const REMOVE_USER_DEPARTMENT_FAIL = "REMOVE_USER_DEPARTMENT_FAIL";
export const FETCH_USER_DEPARTMENTS_SUCCESS = "FETCH_USER_DEPARTMENTS_SUCCESS";
export const FETCH_USER_DEPARTMENTS_FAIL = "FETCH_USER_DEPARTMENTS_FAIL";

export const CHANGE_ROLE_SUCCESS = "CHANGE_ROLE_SUCCESS";
export const CHANGE_ROLE_FAIL = "CHANGE_ROLE_FAIL";

export const MANUAL_CREATE_USER_SUCCESS = "MANUAL_CREATE_USER_SUCCESS";
export const MANUAL_CREATE_USER_FAIL = "MANUAL_CREATE_USER_FAIL";

export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAIL = "DELETE_USER_FAIL";

export const CUSTOMER_CHATBOT_SUCCESS = "CUSTOMER_CHATBOT_SUCCESS";
export const CUSTOMER_CHATBOT_FAIL = "CUSTOMER_CHATBOT_FAIL";

export const FETCH_CUSTOMER_CHATBOT_SUCCESS = "FETCH_CUSTOMER_CHATBOT_SUCCESS";
export const FETCH_CUSTOMER_CHATBOT_FAIL = "FETCH_CUSTOMER_CHATBOT_FAIL";

export const CUSTOMER_CHATBOT_STREAM_START = "CUSTOMER_CHATBOT_STREAM_START";
export const CUSTOMER_CHATBOT_STREAM_CHUNK = "CUSTOMER_CHATBOT_STREAM_CHUNK";
export const CUSTOMER_CHATBOT_STREAM_DONE = "CUSTOMER_CHATBOT_STREAM_DONE";
export const CUSTOMER_CHATBOT_STREAM_ERROR = "CUSTOMER_CHATBOT_STREAM_ERROR";

export const CHAT_STREAM_START = "CHAT_STREAM_START";
export const CHAT_STREAM_CHUNK = "CHAT_STREAM_CHUNK";
export const CHAT_STREAM_DONE = "CHAT_STREAM_DONE";
export const CHAT_STREAM_ERROR = "CHAT_STREAM_ERROR";

// PDF Template Types
export const FETCH_PDF_TEMPLATES_SUCCESS = "FETCH_PDF_TEMPLATES_SUCCESS";
export const FETCH_PDF_TEMPLATES_FAIL = "FETCH_PDF_TEMPLATES_FAIL";
export const UPLOAD_PDF_TEMPLATE_SUCCESS = "UPLOAD_PDF_TEMPLATE_SUCCESS";
export const UPLOAD_PDF_TEMPLATE_FAIL = "UPLOAD_PDF_TEMPLATE_FAIL";
export const DELETE_PDF_TEMPLATE_SUCCESS = "DELETE_PDF_TEMPLATE_SUCCESS";
export const DELETE_PDF_TEMPLATE_FAIL = "DELETE_PDF_TEMPLATE_FAIL";
export const SET_ACTIVE_PDF_TEMPLATE = "SET_ACTIVE_PDF_TEMPLATE";
export const SAVE_PDF_TEMPLATE_FIELDS_SUCCESS = "SAVE_PDF_TEMPLATE_FIELDS_SUCCESS";
export const SAVE_PDF_TEMPLATE_FIELDS_FAIL = "SAVE_PDF_TEMPLATE_FIELDS_FAIL";
export const CREATE_PDF_TEMPLATE_INSTANCE_SUCCESS = "CREATE_PDF_TEMPLATE_INSTANCE_SUCCESS";
export const CREATE_PDF_TEMPLATE_INSTANCE_FAIL = "CREATE_PDF_TEMPLATE_INSTANCE_FAIL";
export const UPDATE_PDF_TEMPLATE_INSTANCE_SUCCESS = "UPDATE_PDF_TEMPLATE_INSTANCE_SUCCESS";
export const UPDATE_PDF_TEMPLATE_INSTANCE_FAIL = "UPDATE_PDF_TEMPLATE_INSTANCE_FAIL";
export const RENDER_PDF_TEMPLATE_INSTANCE_SUCCESS = "RENDER_PDF_TEMPLATE_INSTANCE_SUCCESS";
export const RENDER_PDF_TEMPLATE_INSTANCE_FAIL = "RENDER_PDF_TEMPLATE_INSTANCE_FAIL";
export const RESET_PDF_TEMPLATE_STATE = "RESET_PDF_TEMPLATE_STATE";

// Calls Types
export const FETCH_ALL_CALLS_REQUEST = "FETCH_ALL_CALLS_REQUEST";
export const FETCH_ALL_CALLS_SUCCESS = "FETCH_ALL_CALLS_SUCCESS";
export const FETCH_ALL_CALLS_FAILURE = "FETCH_ALL_CALLS_FAILURE";
export const FETCH_CALL_TRANSCRIPT_REQUEST = "FETCH_CALL_TRANSCRIPT_REQUEST";
export const FETCH_CALL_TRANSCRIPT_SUCCESS = "FETCH_CALL_TRANSCRIPT_SUCCESS";
export const FETCH_CALL_TRANSCRIPT_FAILURE = "FETCH_CALL_TRANSCRIPT_FAILURE";
export const SELECT_CALL = "SELECT_CALL";
export const CLEAR_CALL_ERROR = "CLEAR_CALL_ERROR";
